var $ = require('jquery');

$(function () {

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);

    var loadingdiv = document.querySelector('#loadingDiv');
    var containerError = document.querySelector('#containerError');

    if ($(".search-page__submit").length > 0 && window.location.href.indexOf('/search') != -1) {
        if (queryString) {
            if (!urlParams.get('q')) {
                loadingdiv.classList.remove('show');
            }
        } else {
            loadingdiv.classList.remove('show');
        }
    }

    var page = 1;
    var firmPage = 1;
    var contentPaginated = false;
    var firmPaginated = false;
    var cityIds = [];
    var serviceIds = [];
    var filterResults = function () {
        var checkedServices = $('[data-services]').find("input:checked");
        var payload = $($(".search-page__submit").siblings(".search-page__textbox"))[0].value;
        serviceIds = [];

        checkedServices.each(function () {
            serviceIds.push($(this).data("id"));
        });
        if (serviceIds.length > 0) {
            $(".dropdown-filter-clear").show();
            $(".firm-results__filter__filters__label").hide();
        } else {
            $(".dropdown-filter-clear").hide();
            $(".firm-results__filter__filters__label").show();
        }
        $.ajax(
            {
                url: "/api/Sitecore/SearchPage/HandleFilterSubmit",
                type: "POST",
                context: this,
                data: {
                    payload: payload,
                    page: firmPage,
                    pageSize: $(".search-page").data("firm-page-size"),
                    contextId: $(".search-page").data("page-id"),
                    contextLang: $(".search-page").data("page-language") || $('html').attr('lang'),
                    checkedServices: serviceIds
                },
                success: function (data) {
                    $(".firm-results__results-container").replaceWith(data.firmResults);
                    $(".firm-results__filter__count-wrapper").replaceWith(data.counter);
                    $(".firm-results__filter__result-count--initial").hide();
                },
                error: function (data) {
                    console.error(data);
                }
            });
    }

    var changeFirmPage = function () {
        var payload = $($(".search-page__submit").siblings(".search-page__textbox"))[0].value;
        window.history.pushState(payload, payload, window.location.pathname + "?q=" + payload + "&fpage=" + firmPage);
        $.ajax(
            {
                url: "/api/Sitecore/SearchPage/HandleFirmPage",
                type: "POST",
                context: this,
                data: {
                    payload: payload,
                    firmPage: firmPage,
                    firmPageSize: $(".search-page").data("firm-page-size"),
                    contextId: $(".search-page").data("page-id")
                },
                success: function (data) {
                    if (data.error) {
                        console.error("an error occured " + data.errorMessage);
                        return;
                    }
                    $(".firm-results__results-container").replaceWith(data.firmResults);
                    $(".firm-results__filter__count-wrapper").replaceWith(data.counter);
                    $(".firm-results__filter__result-count--initial").hide();

                },
                error: function (data) {
                    console.error(data);
                }
            });


    }
    //enter press for header search
    $(".search__textbox").on("keypress",
        function(e) {
            if (e.keyCode === 13) {
                $(".search__button").click();
            }
        }
    );
    //header search button click
    $(".search__button").on("click",
        function(e) {
            e.preventDefault();
            var searchpage = $(this).closest(".search").data("search-page");
            var searchTest = encodeURI($($(this).siblings(".search__textbox"))[0].value);
            window.location = searchpage + "?q=" + searchTest;
        }
    );

    //enter press for search page
    $(".search-page__textbox").on("keypress",
        function (e) {
            if (e.keyCode === 13) {
                $(".search-page__submit").click();
            }
        }
    );

    //search page search function
    $(".search-page__submit").on("click", function (e) {
        showLoadingImg(true);
        submitSearch(e, true);
    });

    function submitSearch(e, resetPageNumber) {
        if (!!resetPageNumber) {
            page = 1;
        }
        if(!!e){ e.preventDefault();}
        var payload = $($(".search-page__submit").siblings(".search-page__textbox"))[0].value;
        containerError.classList.add('hide');

        //update the url so backbutton works
        if (payload.length > 0) {
            if (contentPaginated) {
                window.history.pushState(payload,
                    payload,
                    window.location.pathname + "?q=" + payload + "&page" + page);
            }
            if (firmPaginated) {
                window.history.pushState(payload,
                    payload,
                    window.location.pathname + "?q=" + payload + "&page=" + firmPage);
            } else {
                window.history.pushState(payload,
                    payload,
                    window.location.pathname + "?q=" + payload);
            }
            var isFirmSearch = $(".firm-results:visible").length > 0;
            $.ajax(
                {
                    url: "/api/Sitecore/SearchPage/HandleSearchSubmit",
                    type: "POST",
                    context: this,
                    data: {
                        payload: payload,
                        page: page,
                        firmPage: firmPage,
                        pageSize: $(".search-page").data("page-size"),
                        firmPageSize: $(".search-page__submit").closest(".search-page").data("firm-page-size"),
                        contextId: $(".search-page").data("page-id"),
                        contextLang: $(".search-page").data("page-language") || $('html').attr('lang'),
                        isFirm: isFirmSearch
                    },
                    success: function(data) {
                        if (data.error) {
                            console.error("an error occured " + data.errorMessage);
                            return;
                        }
                        var queryLabel = $(".search-query__container").data("query-label").replace("{query}", payload);
                        $(".search-query__container").html(queryLabel);

                        if (!!data.suggestion) {
                            var search = window.location.href;
                            var replace = search.replace("q=" + encodeURIComponent(payload), "q=" + encodeURIComponent(data.suggestion));

                            $(".search-criteria__suggestion").show();
                            $(".search-criteria__suggestion-link").attr("href", replace);
                            $(".search-criteria__suggestion-link").text(data.suggestion);


                        } else {
                            $(".search-criteria__suggestion").hide();
                        }

                        $(".content-results").replaceWith(data.contentResults);
                        $(".content-results").show();
                        if (isFirmSearch) {
                            $(".firm-results").replaceWith(data.firmResults);
                            $(".firm-results").show();
                            $(".search-result-tabs").show();
                        }
                        if (contentPaginated) {
                            $(".search-result-tabs__content").click();
                        }
                        else if (firmPaginated) {
                            $(".search-result-tabs__firms").click();
                        } else {
                            $(".search-result-tabs__all").click();
                        }
                    },
                    error: function (data) {
                        if (data.status == 500 && data.statusText == "error") {
                            $(".search-query__container").html("");
                            $(".search-result-tabs").hide();
                            $(".content-results").hide();
                            $(".firm-results").hide();
                            containerError.classList.remove('hide');
                            loadingdiv.classList.remove('show');
                        }
                        console.error(data);
                    }
                });
        } else {
            $(".search-result-tabs").hide();
            $(".content-results").hide();
            $(".firm-results").hide();
            $(".firm-results__results--extra").hide();
            $(".search-query__container").html("");
            window.history.pushState("", "", window.location.pathname);
        }
    }

    //filter results when a filter is clicked
    $("body").on("change",
        ".firm-results__filter__filters .form__field--checkbox",
        function () {
            firmPage = 1;
            $(".search-result-tabs__firms").click();
            filterResults();
        });
    //clear results when clear is clicked
    $("body").on("click",
        ".dropdown-filter-clear",
        function (e) {
            e.preventDefault();
            firmPage = 1;
            cityIds = [];
            serviceIds = [];
            $(".firm-results__filter__filters .form__field--checkbox input:checked").prop('checked', false);
            filterResults();
        });
    //enter press for search page
    $(".search-page__textbox").on("keypress",
        function(e) {
            if (e.keyCode === 13) {
                submitSearch(null, true);
                $(".search-page__textbox").blur();
            }
        }
    );

    //search if on search page and querystring is filled in 
    if ($(".search-page__textbox").length > 0 && $.QueryString["q"]) {
        if ($.QueryString["page"] && $.isNumeric($.QueryString["page"])) {
            page = Number.parseInt($.QueryString["page"]);
        }
        $(".search-page__textbox").val($.QueryString["q"]);
        submitSearch(null, false);
    }

    //All Tab Clicked
    $(".search-result-tabs__all").on("click",
        function(e) {
            e.preventDefault();
            $(this).addClass("active").siblings().removeClass("active");
            $(".content-results").show();
            $(".firm-results").show();
            $(".firm-results__results--extra").hide();
            $(".firm-results__filter__result-count--initial").show();
            $(".firm-results__filter__result-count--extra").hide();
            $(".firm-results__show-more").show();
            $(".firm-results__pagination").hide();
            page = 1;
            firmPage = 1;
            contentPaginated = false;
            //if we're beyond page 1 for firm results reset back
            if (firmPaginated) {
                firmPaginated = false;
                submitSearch(null, false);
            }
        }
    );
    //See More Firms trigger
    $("body").on("click", ".firm-results__show-more a",

        function(e) {
            e.preventDefault();
            $(".search-result-tabs__firms").click();
        }
    );
    //Firm Tab Clicked
    $(".search-result-tabs__firms").on("click",
        function (e) {
            e.preventDefault();
            $(this).addClass("active").siblings().removeClass("active");
            $(".content-results").hide();
            $(".firm-results").show();
            $(".firm-results__results--extra").show();
            $(".firm-results__filter__result-count--initial").hide();
            $(".firm-results__filter__result-count--extra").show();
            $(".firm-results__show-more").hide();
            $(".firm-results__pagination").show();
        }
    );

    //Content Tab Clicked
    $(".search-result-tabs__content").on("click",
        function (e) {
            e.preventDefault();
            $(this).addClass("active").siblings().removeClass("active");
            $(".content-results").show();
            $(".firm-results").hide();
            $(".firm-results__results--extra").hide();
        }
    );
    var scrollSpeed = 500;
    var scrollToTopOfResults = function () {
        $('html, body').animate({
            scrollTop: $(".content-results").offset().top
        }, scrollSpeed);
    };

    //Content pagination code
    $("body").on("click", ".content-results__pagination__page",
        function (e) {
            e.preventDefault();
            $(".search-result-tabs__content").click();
            firmPage = 1;
            contentPaginated = true;
            firmPaginated = false;
            $(".content-results__results .loading").addClass("show");
            page = $(this).data("page");
            submitSearch(null, false);
            scrollToTopOfResults();
        }
    );
    $("body").on("click", ".content-results__pagination .left",
        function (e) {
            e.preventDefault();
            contentPaginated = true;
            firmPaginated = false;
            $(".search-result-tabs__content").click();
            $(".content-results__results .loading").addClass("show");
            page = page - 1;
            submitSearch(null, false);
            scrollToTopOfResults();
        }
    );
    $("body").on("click", ".content-results__pagination .right",
        function (e) {
            e.preventDefault();
            contentPaginated = true;
            firmPaginated = false;
            $(".search-result-tabs__content").click();
            $(".content-results__results .loading").addClass("show");
            page = page + 1;
            submitSearch(null, false);
            scrollToTopOfResults();
        }
    );

    //firm pagination code
    $("body").on("click", ".firm-results__pagination__page",
        function (e) {
            e.preventDefault();
            page = 1;
            contentPaginated = false;
            firmPaginated = true;
            firmPage = $(this).data("page");
            if (cityIds.length > 0 || serviceIds.length > 0) {
                filterResults();
            } else {
                changeFirmPage();
            }
            scrollToTopOfResults();
        }
    );
    $("body").on("click", ".firm-results__pagination .left",
        function (e) {
            e.preventDefault();
            firmPage = firmPage - 1;
            contentPaginated = false;
            firmPaginated = true;
            if (cityIds.length > 0 || serviceIds.length > 0) {
                filterResults();
            } else {
                changeFirmPage();
            }
            scrollToTopOfResults();
        }
    );
    $("body").on("click", ".firm-results__pagination .right",
        function (e) {
            e.preventDefault();
            contentPaginated = false;
            firmPaginated = true;
            firmPage = firmPage + 1;
            if (cityIds.length > 0 || serviceIds.length > 0) {
                filterResults();
            } else {
                changeFirmPage();
            }
            scrollToTopOfResults();
        }
    );
    //city overlay code
    $("body").on("click", ".firm-results__results__result__cities", function(e) {
        e.preventDefault();
        var id = $(this).data("firm-id");
        $.ajax(
            {
                url: "/api/Sitecore/SearchPage/CityResults",
                type: "POST",
                context: this,
                data: {
                    firmId: id,
                    searchPageId: $(".search-page").data("page-id")
                },
                success: function (data) {
                    $.fancybox.open({
                        src: data,
                        type: 'html'
                    });
                },
                error: function (data) {
                    console.error(data);
                }
            });
    });

    //autocomplete for search
    $(function () {
        $(".autocomplete").each(function (index, currentInputBox) {
            $(currentInputBox).autocomplete({
                delay: $(currentInputBox).data("autocomplete-delay"),
                minLength: $(currentInputBox).data("autocomplete-min"),
                source: function(request, response) {
                    $.ajax({
                        url: "/api/Sitecore/SearchPage/GetAutocompleteSuggestions",
                        type: "POST",
                        dataType: "json",
                        data: {
                            searchTerm: request.term,
                            contextID: $(currentInputBox).data("page-id"),
                            language: $(".search-page").data("page-language") || $('html').attr('lang'),
                        },
                        success: function(data) {
                            response(data);
                        }
                    });
                },
                select: function(event, ui) {
                    event.target.value = stripHTML(ui.item.value);
                    $(currentInputBox).next("button").click();
                    event.stopPropagation();
                },
                focus: function (event, ui) {
                    ui.item.value = stripHTML(ui.item.value);
                    event.stopPropagation();
                },
                appendTo: $(currentInputBox).data("autocomplete-container")
            }).data("ui-autocomplete")._renderItem = autoCompleteRender;
        });
    });

    function autoCompleteRender(ul, item) {
        var searchTerm = this.term;
        var itemLabel = item.label;
        itemLabel = itemLabel.replace(new RegExp("(" + searchTerm + ")", "gi"), '$1');
        return $("<li></li>").data("item.autocomplete", item).append("<a><i class='material-icons material-icons--search'>search</i>" + itemLabel + "</a>").appendTo(ul);
    }

    function stripHTML(oldString) {
        return oldString.replace(/<(?:.|\n)*?>/gm, '');
    }

    // based on true / false either show the loading at the top or hide it and remove top class
    function showLoadingImg(showLoading)
    {
        if (showLoading) {
            $(".content-results__results .loading").addClass("show");
            $(".content-results__results .loading img").addClass("top");
        }
        else {
            $(".content-results__results .loading").removeClass("show");
            $(".content-results__results .loading img").removeClass("top");
        }
    }
});
